module.exports = __webpack_public_path__ + "img/type_PSYCHIC.8898e3e0.png";